import { render, staticRenderFns } from "./SearchConstel.vue?vue&type=template&id=84408c78&scoped=true"
import script from "./SearchConstel.vue?vue&type=script&lang=js"
export * from "./SearchConstel.vue?vue&type=script&lang=js"
import style0 from "./SearchConstel.vue?vue&type=style&index=0&id=84408c78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84408c78",
  null
  
)

export default component.exports